import { Tooltip, useDisclosure } from "@chakra-ui/react";
import { useState } from "react";
import { Link, useNavigate } from "react-router-dom";
import { BsPencil } from "react-icons/bs";
import { MdOutlineDeleteForever } from "react-icons/md";
import { DeleteNotification } from "../Modals/DeleteNotification";
import { SendNotification } from "../Modals/SendNotification";
import { IoIosSend } from "react-icons/io";

export const SingleRowList = ({ props, func, id }: any) => {
  const navigate = useNavigate();
  // notifications/edit/:id
  const { isOpen, onOpen, onClose } = useDisclosure();
  const {
    _id,
    name,
    title,
    body,
    image_url,
    path,
    created_date,
    created_time,
    category,
  } = props;
  const [modal, setModal] = useState("");

  return (
    <tr>
      <td>
        <div
          className="edit-icon"
          onClick={() => navigate(`/notifications/edit/${id}`)}
        >
          <BsPencil />
        </div>
      </td>
      <td>{_id}</td>
      <td>{name}</td>
      <td>{title}</td>
      <td>{body}</td>
      <td>{path}</td>
      <td>{image_url}</td>
      <td>
        {created_date}-{created_time}
      </td>
      <td>
        <div className="flex justify-content-center">
          {category !== "automatic" && (
            <div>
              <span title="App notification">
                <IoIosSend
                  className="button-icon pointer"
                  onClick={() => {
                    setModal("sendModal");
                    onOpen();
                  }}
                />
              </span>
            </div>
          )}
          <div className="d-flex align-items-center">
            <span title="Delete">
              <MdOutlineDeleteForever
                className="deleteButton pointer"
                onClick={() => {
                  setModal("deletemodal");
                  onOpen();
                }}
              />
            </span>
          </div>
        </div>
      </td>
      {modal === "deletemodal" && (
        <DeleteNotification
          isOpen={isOpen}
          onClose={onClose}
          func={func}
          id={_id}
        />
      )}
      {modal === "sendModal" && (
        <SendNotification
          isOpen={isOpen}
          onClose={onClose}
          func={func}
          id={_id}
        />
      )}
    </tr>
  );
};
